export const baseUrl = process.env.REACT_APP_ROOT_API;
